export function loadMessages(storageKey, expiresKey) {
    try {
        const expiresAt = Number(localStorage.getItem(expiresKey) || 0);
        if (expiresAt && Date.now() > expiresAt) {
            localStorage.removeItem(storageKey);
            localStorage.removeItem(expiresKey);
            return [];
        }
        const raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function saveMessages(storageKey, expiresKey, messages, expirationMs) {
    try {
        localStorage.setItem(storageKey, JSON.stringify(messages));
        const currentExpires = Number(localStorage.getItem(expiresKey) || 0);
        if (!currentExpires) {
            localStorage.setItem(expiresKey, String(Date.now() + expirationMs));
        }
    } catch {}
}

export function clearMessages(storageKey, expiresKey) {
    try {
        localStorage.removeItem(storageKey);
        localStorage.removeItem(expiresKey);
    } catch {}
}

export function checkExpiration(expiresKey) {
    try {
        const expiresAt = Number(localStorage.getItem(expiresKey) || 0);
        return expiresAt && Date.now() > expiresAt;
    } catch {
        return false;
    }
}
